<template>
  <div>
    <edit-page-header
      page="NOTICE"
      :is-date-visible="false"
    >
      <router-link
        to="/notices/create"
        class="btn btn-primary"
      >
        공지 등록
      </router-link>
    </edit-page-header>

    <el-table
      :data="noticeCurrentPageList"
      style="width: 100%"
      class="fifl-main-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      row-class-name="fifl-table-row"
      cell-class-name="fifl-main-table-cell"
      @row-click="handleClickNoticeRow"
      @sort-change="handleClickSortByDate"
    >
      <el-table-column
        prop="index"
        label="번호"
        :width="tableColWidth.index"
      />
      <el-table-column
        prop="title"
        label="제목"
        show-overflow-tooltip
        :width="tableColWidth.title"
      />
      <el-table-column
        sortable
        prop="created"
        label="일시"
        :width="tableColWidth.created"
      >
        <template slot-scope="scope">
          {{ format(scope.row.created, 'YYYY.MM.DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <div
        slot="empty"
        class="table-empty-container"
      >
        <warning-message
          v-show="isContentLoaded"
          message="등록된 공지가 없습니다."
        />
      </div>
    </el-table>

    <div style="margin-top: 25px; text-align: center;">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :total="notices.length"
      />
    </div>
  </div>
</template>

<script>
import ElMainTable from "@/components/element-ui/ElMainTable";
import WarningMessage from "@/components/element-ui/WarningMessage";
import { format } from "date-fns";
import NoticeHeader from "./NoticeHeader";
import EditPageHeader from "@/components/EditPageHeader";
import resizePageMixin from "@/mixins/resizePageMixin";
import _ from "lodash";
import { fiflboxApi } from '@/utils/api';

const RESPONSIVE_TABLE_WIDTH = {
	mobile: {
		index: 50,
		title: null,
		created: 140,
	},
	desktop: {
		index: 95,
		title: null,
		created: 162,
	},
};

export default {
	name: "Notice",
	components: {
		EditPageHeader,
		NoticeHeader,
		WarningMessage,
		ElMainTable,
	},
	mixins: [resizePageMixin],
	data() {
		return {
			pageSize: 10,
			currentPage: 1,
			notices: [],
			tableColWidth: RESPONSIVE_TABLE_WIDTH["desktop"],
			isContentLoaded: false,
		};
	},
	computed: {
		noticeCurrentPageList() {
			let startId = (this.currentPage - 1) * this.pageSize;
			let endId = this.currentPage * this.pageSize;

			return this.notices.slice(startId, endId);
		},
	},
	async created() {
		let { data: notices } = await fiflboxApi.v1.getCenterNotice();
		let noticeLength = notices.length;

		this.notices = notices.map((notice, index) => {
			return {
				...notice,
				index: noticeLength - index,
			};
		});
		this.isContentLoaded = true;
	},
	methods: {
		format,
		handleClickNoticeRow(row, event, column) {
			this.$router.push(`/notices/${row.id}`).catch(()=>{});
		},
		handleClickSortByDate({ column, prop, order }) {
			let orders = order === "ascending" ? "asc" : "desc";
			this.notices = _.orderBy(this.notices, ["created"], [orders]);
		},
		onResize() {
			this.tableColWidth =
				RESPONSIVE_TABLE_WIDTH[window.innerWidth < 768 ? "mobile" : "desktop"];
		},
	},
};
</script>
